import React, { Component } from "react";
import { View, TextInput, StyleSheet, Platform } from "react-native";

import Text from "components/StyledText";

import * as x from "../../styles/css";

class Textfield extends Component {
	constructor(props) {
		super(props);

		this.renderAccessory = this.renderAccessory.bind(this);
	}

	renderAccessory() {
		let { renderAccessory } = this.props;

		if ("function" !== typeof renderAccessory) {
			return null;
		}

		return <View style={[styles.accessory]}>{renderAccessory()}</View>;
	}

	render() {
		return (
			<View style={[this.props.containerStyle]}>
				{this.props.label ? (
					<Text style={[styles.label]}>{this.props.label}</Text>
				) : (
					<View style={[styles.label]} />
				)}
				<View
					style={[
						x.flexDirection.row,
						{
							borderRadius: 1,
							borderWidth: this.props.error ? 2 : 1,
							borderColor: this.props.error
								? x.colors.error
								: "rgba(0,0,0,0.2)",
						},
					]}
				>
					{this.props.flag && (
						<Text
							style={{
								height: 40,
								paddingTop: Platform.OS == "web" ? 7 : 11,
								paddingLeft: 4,
								...this.props.style,
							}}
						>
							{`${this.props.flag} ${"+"}`}
						</Text>
					)}
					<TextInput
						style={{
							height: 40,
							padding: 5,
							color: "black",
							borderRadius: 5,
							flex: 1,
							...this.props.style,
						}}
						allowFontScaling={false}
						value={this.props.value}
						placeholder={this.props.placeholder}
						placeholderTextColor={"gray"}
						onChangeText={this.props.onChangeText}
						keyboardType={this.props.keyboardType}
						blurOnSubmit={this.props.blurOnSubmit}
						secureTextEntry={this.props.secureTextEntry}
						returnKeyType={this.props.returnKeyType}
						autoCapitalize={this.props.autoCapitalize}
						onSubmitEditing={this.props.onSubmitEditing}
						underlineColorAndroid="transparent"
						editable={this.props.isEditable}
					/>
					{this.renderAccessory()}
				</View>

				<View style={{ marginBottom: 20 }}>
					{this.props.error != undefined &&
						this.props.error.length > 0 && (
							<Text
								style={{
									paddingTop: 8,
									color: "#EF9A9A",
								}}
							>
								{this.props.error}
							</Text>
						)}
				</View>
			</View>
		);
	}
}

const styles = StyleSheet.create({
	inputContainer: {
		backgroundColor: "transparent",
	},
	input: {
		top: 2,
		padding: 0,
		margin: 0,
		flex: 1,
	},
	row: {
		flexDirection: "row",
	},
	flex: {
		flex: 1,
	},
	accessory: {
		justifyContent: "center",
		alignSelf: "flex-start",
		height: 40,
	},
	label: {
		color: "gray",
		marginBottom: 10,
	},
});

export default Textfield;



// WEBPACK FOOTER //
// ./src/components/Textfield/index.js